import type { Chapter } from '@fixit/bozp-content';

/** Per-chapter interaction state the LMS shell accumulates as the worker reads. */
export interface ChapterGateState {
  scrolledToEnd: boolean;
  widgetIds: string[];
  /** Seconds the chapter has been the focused one in this visit (client clock). */
  dwellSeconds: number;
}

/**
 * A chapter is complete once the worker has scrolled to its end, interacted with every
 * `requiredWidgetIds` (no gate if unset) and stayed on it for `minDwellSeconds` (no gate if
 * unset). Drives the sequential chapter unlock + the quiz lock. The server re-derives the
 * same three rules from its own event timestamps at submit (`bozp-session-gate.ts`), with a
 * 10 % tolerance on dwell — so this gate is the worker's guide, never the evidence.
 */
export function isChapterComplete(chapter: Chapter, state: ChapterGateState): boolean {
  if (!state.scrolledToEnd) return false;
  if ((chapter.minDwellSeconds ?? 0) > state.dwellSeconds) return false;
  return (chapter.requiredWidgetIds ?? []).every((id) => state.widgetIds.includes(id));
}
